/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ContainerHeight } from '../model';
// @ts-ignore
import type { ContainerJourneyResponseDto } from '../model';
// @ts-ignore
import type { ContainerJourneySimpleResponseDto } from '../model';
// @ts-ignore
import type { ContainerType } from '../model';
// @ts-ignore
import type { GetContainerJourneysQuery } from '../model';
/**
 * ContainerJourneysApi - axios parameter creator
 */
export const ContainerJourneysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GetContainerJourneysQuery} [getContainerJourneysQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByContainerIds: async (getContainerJourneysQuery?: GetContainerJourneysQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/ContainerJourneys/GetByContainerIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getContainerJourneysQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [containerNumbers] 
         * @param {boolean} [includeCompleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByContainerNumbers: async (containerNumbers?: Array<string>, includeCompleted?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/ContainerJourneys/getByContainerNumbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerNumbers) {
                localVarQueryParameter['ContainerNumbers'] = containerNumbers;
            }

            if (includeCompleted !== undefined) {
                localVarQueryParameter['IncludeCompleted'] = includeCompleted;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [length] 
         * @param {ContainerHeight} [height] 
         * @param {ContainerType} [type] 
         * @param {string} [operator] 
         * @param {string} [isoCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByNonNumeric: async (length?: number, height?: ContainerHeight, type?: ContainerType, operator?: string, isoCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/ContainerJourneys/getByNonNumeric`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (length !== undefined) {
                localVarQueryParameter['Length'] = length;
            }

            if (height !== undefined) {
                localVarQueryParameter['Height'] = height;
            }

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }

            if (operator !== undefined) {
                localVarQueryParameter['Operator'] = operator;
            }

            if (isoCode !== undefined) {
                localVarQueryParameter['IsoCode'] = isoCode;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [orderIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByOrderIds: async (orderIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/ContainerJourneys/getByOrderIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (orderIds) {
                localVarQueryParameter['OrderIds'] = orderIds;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [partialContainerNumber] 
         * @param {boolean} [isOnTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPartialContainerNumber: async (partialContainerNumber?: string, isOnTerminal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/ContainerJourneys/getByPartialContainerNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (partialContainerNumber !== undefined) {
                localVarQueryParameter['PartialContainerNumber'] = partialContainerNumber;
            }

            if (isOnTerminal !== undefined) {
                localVarQueryParameter['IsOnTerminal'] = isOnTerminal;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContainerJourneysApi - functional programming interface
 */
export const ContainerJourneysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContainerJourneysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {GetContainerJourneysQuery} [getContainerJourneysQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByContainerIds(getContainerJourneysQuery?: GetContainerJourneysQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerJourneyResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByContainerIds(getContainerJourneysQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerJourneysApi.getByContainerIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [containerNumbers] 
         * @param {boolean} [includeCompleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByContainerNumbers(containerNumbers?: Array<string>, includeCompleted?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerJourneyResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByContainerNumbers(containerNumbers, includeCompleted, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerJourneysApi.getByContainerNumbers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [length] 
         * @param {ContainerHeight} [height] 
         * @param {ContainerType} [type] 
         * @param {string} [operator] 
         * @param {string} [isoCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByNonNumeric(length?: number, height?: ContainerHeight, type?: ContainerType, operator?: string, isoCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerJourneyResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByNonNumeric(length, height, type, operator, isoCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerJourneysApi.getByNonNumeric']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} [orderIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByOrderIds(orderIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerJourneyResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByOrderIds(orderIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerJourneysApi.getByOrderIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [partialContainerNumber] 
         * @param {boolean} [isOnTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByPartialContainerNumber(partialContainerNumber?: string, isOnTerminal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerJourneySimpleResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByPartialContainerNumber(partialContainerNumber, isOnTerminal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerJourneysApi.getByPartialContainerNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContainerJourneysApi - factory interface
 */
export const ContainerJourneysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContainerJourneysApiFp(configuration)
    return {
        /**
         * 
         * @param {GetContainerJourneysQuery} [getContainerJourneysQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByContainerIds(getContainerJourneysQuery?: GetContainerJourneysQuery, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerJourneyResponseDto>> {
            return localVarFp.getByContainerIds(getContainerJourneysQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [containerNumbers] 
         * @param {boolean} [includeCompleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByContainerNumbers(containerNumbers?: Array<string>, includeCompleted?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerJourneyResponseDto>> {
            return localVarFp.getByContainerNumbers(containerNumbers, includeCompleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [length] 
         * @param {ContainerHeight} [height] 
         * @param {ContainerType} [type] 
         * @param {string} [operator] 
         * @param {string} [isoCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByNonNumeric(length?: number, height?: ContainerHeight, type?: ContainerType, operator?: string, isoCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerJourneyResponseDto>> {
            return localVarFp.getByNonNumeric(length, height, type, operator, isoCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [orderIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByOrderIds(orderIds?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerJourneyResponseDto>> {
            return localVarFp.getByOrderIds(orderIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [partialContainerNumber] 
         * @param {boolean} [isOnTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPartialContainerNumber(partialContainerNumber?: string, isOnTerminal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerJourneySimpleResponseDto>> {
            return localVarFp.getByPartialContainerNumber(partialContainerNumber, isOnTerminal, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContainerJourneysApi - object-oriented interface
 */
export class ContainerJourneysApi extends BaseAPI {
    /**
     * 
     * @param {GetContainerJourneysQuery} [getContainerJourneysQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByContainerIds(getContainerJourneysQuery?: GetContainerJourneysQuery, options?: RawAxiosRequestConfig) {
        return ContainerJourneysApiFp(this.configuration).getByContainerIds(getContainerJourneysQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [containerNumbers] 
     * @param {boolean} [includeCompleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByContainerNumbers(containerNumbers?: Array<string>, includeCompleted?: boolean, options?: RawAxiosRequestConfig) {
        return ContainerJourneysApiFp(this.configuration).getByContainerNumbers(containerNumbers, includeCompleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [length] 
     * @param {ContainerHeight} [height] 
     * @param {ContainerType} [type] 
     * @param {string} [operator] 
     * @param {string} [isoCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByNonNumeric(length?: number, height?: ContainerHeight, type?: ContainerType, operator?: string, isoCode?: string, options?: RawAxiosRequestConfig) {
        return ContainerJourneysApiFp(this.configuration).getByNonNumeric(length, height, type, operator, isoCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [orderIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByOrderIds(orderIds?: Array<number>, options?: RawAxiosRequestConfig) {
        return ContainerJourneysApiFp(this.configuration).getByOrderIds(orderIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [partialContainerNumber] 
     * @param {boolean} [isOnTerminal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByPartialContainerNumber(partialContainerNumber?: string, isOnTerminal?: boolean, options?: RawAxiosRequestConfig) {
        return ContainerJourneysApiFp(this.configuration).getByPartialContainerNumber(partialContainerNumber, isOnTerminal, options).then((request) => request(this.axios, this.basePath));
    }
}

